import React from 'react';
import { FlexCard, FlexImage, FlexSection } from './FlexCard';

function Categories({collection}) {
    const redirect=(path)=>{
        if(path.toLowerCase().includes("skincare"))path="skincare";
        window.location.href=`/${path.toLowerCase()}`;
    }
    return (
    <div>
        <h2 style={{textAlign: 'center', color: '#eee'}}>Shop by Category</h2>
        <FlexSection>
            {collection?.map((category, i) => (
                <FlexCard onClick={()=>redirect(category)} key={i}>
                    <FlexImage src={`/images/${category}.png`} alt={category} />
                    <h3>{category}</h3>
                </FlexCard>
            ))}
        </FlexSection></div>
  );
}

export default Categories;
